import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import 'bootstrap/dist/css/bootstrap.min.css';
import emailjs from '@emailjs/browser';
import { Google } from 'react-bootstrap-icons';
import { styled } from '@mui/material/styles';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import Logo from '../assets/images/logo.webp'

// Note: You'll need to set up EmailJS with your credentials
// 1. Sign up at https://www.emailjs.com/
// 2. Create an email service (Gmail, etc.)
// 3. Create an email template
// 4. Replace the placeholders below with your actual EmailJS credentials

const Home = () => {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [showFeedbackForm, setShowFeedbackForm] = useState(false);
  const [feedback, setFeedback] = useState('');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  // Initialize EmailJS
  useEffect(() => {
    emailjs.init('BA5-kZyV9Nqd38mUU');
  }, []);

  const handleRatingClick = (value) => {
    setRating(value);
    
    // For 1-4 stars, show feedback form
    if (value < 5) {
      setShowFeedbackForm(true);
    } else {
      // For 5 stars, open Google review link directly
      window.open('https://www.google.com/search?num=10&sca_esv=cb5bdb4b8274c164&rlz=1C1ONGR_enPK1026PK1030&sxsrf=AE3TifPLXiCPPev9Z14ujOeyq3J-TfOAeA:1765461287647&si=AMgyJEuzsz2NflaaWzrzdpjxXXRaJ2hfdMsbe_mSWso6src8s3lXIo8Dh0GXWNYHSdS-TuMXnnFcxaGqJ4UG8ceKTdxnQHujgCWAUJ9p-0xJ-KY9W_HHPWMr-gkVMkYEv25hwptazPejmiI04G6_itw5qvIVX7HiTg%3D%3D&q=Iqbal+Saeed+-+My+Family+MD+LLC+Reviews&sa=X&ved=2ahUKEwjc1Kjn17WRAxVFvycCHRjkNkYQ0bkNegQIORAE&biw=1517&bih=703&dpr=0.9#lrd=0x88626cea37639e9b:0x5c30f864a919d024,3,,,,', '_blank');
      setShowFeedbackForm(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');

    try {
      // Send email using EmailJS
      await emailjs.send(
        'service_myfamilymd',
        'template_myfamilymd',
        {
          full_name: name,
          email: email,
          message: `Rating: ${rating} stars\n\nFeedback: ${feedback}`
        }
      );
      
      setSubmitted(true);
    } catch (err) {
      console.error('Failed to send email:', err);
      setError('Failed to submit your review. Please try again later.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-vh-100 d-flex flex-column" style={{paddingTop:"140px"}}>
      <div className="container flex-grow-1">
        <div className="row justify-content-center">
          <div className="col-lg-6 text-center">
            <img src={Logo} className='w-logo' alt="IM Clinic Logo" />
            <div className="mt-4 pt-2 main-sub-title" style={{color: '#9d0009'}}>
              Building A Healthier Tomorrow
            </div>
          </div>
          <div className="col-lg-6 text-center text-lg-start">
            <div className="col-lg-10 ms-auto">
              <div className="">
                <h1 className="main-title mb-4 mt-5 mt-lg-0" style={{color: '#9d0009'}}>
                  How was your <br className='d-none d-lg-block'/> experience with us?
                </h1>
                
                {!submitted ? (
                  <div className="rating-container my-4">
                    <div className="star-rating mb-3">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <button
                          key={star}
                          type="button"
                          className={`btn btn-lg p-0 me-4 ${star <= (hover || rating) ? 'text-warning' : 'text-muted'}`}
                          style={{
                            color: star <= (hover || rating) ? '#ffc001' : '#e9ecef',
                            '--bs-text-opacity': 1
                          }}
                          onMouseEnter={() => setHover(star)}
                          onMouseLeave={() => setHover(0)}
                          onClick={() => handleRatingClick(star)}
                          aria-label={`Rate ${star} star${star !== 1 ? 's' : ''}`}
                        >
                          {star <= (hover || rating) ? (
                            <StarIcon sx={{ 
                              fontSize: { xs: '2.5rem', sm: '3rem', md: '4rem' },
                              color: '#ffc001' 
                            }} />
                          ) : (
                            <StarBorderIcon sx={{ 
                              fontSize: { xs: '2.5rem', sm: '3rem', md: '4rem' },
                              color: 'black' 
                            }} />
                          )}
                        </button>
                      ))}
                    </div>
                    
                    {showFeedbackForm && rating < 5 && (
                      <div className="mt-4">
                        <p className="mb-3">
                          {rating === 4 
                            ? "Thank you for your rating. We are sorry your visit wasn't a full five-star experience. Your feedback is very important to us — could you please share what we can improve?"
                            : rating <= 3 
                              ? "We are truly sorry your experience didn't meet expectations. Your care and comfort matter deeply to us. Please tell us what went wrong so we can address it immediately."
                              : "We're sorry to hear that. Please tell us how we can improve."
                          }
                        </p>
                        <form onSubmit={handleSubmit} className=''>
                          <div className="mb-3">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Full Name"
                              value={name}
                              onChange={(e) => setName(e.target.value)}
                              required
                            />
                          </div>
                          <div className="mb-3">
                            <input
                              type="email"
                              className="form-control"
                              placeholder="Your email"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                              required
                            />
                          </div>
                          <div className="mb-3">
                            <textarea
                              className="form-control"
                              rows="3"
                              placeholder="Your feedback..."
                              value={feedback}
                              onChange={(e) => setFeedback(e.target.value)}
                              required
                            ></textarea>
                          </div>
                          <button
                            type="submit"
                            className="btn btn-primary px-4"
                            disabled={isSubmitting}
                          >
                            {isSubmitting ? 'Submitting...' : 'Submit Feedback'}
                          </button>
                        </form>
                        {error && <div className="text-danger mt-2">{error}</div>}
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="py-4">
                    <div className="text-success mb-3">
                      <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="currentColor" className="bi bi-check-circle" viewBox="0 0 16 16">
                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                        <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"/>
                      </svg>
                    </div>
                    <h3>Thank You for Your Feedback!</h3>
                    <p className="text-muted">We appreciate you taking the time to help us improve.</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer className="text-center col-7 py-4">
        <div className="d-flex justify-content-center align-items-center gap-4 flex-wrap">
          <a 
            href="https://myfamilymd.org/" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ 
              color: 'black', 
              textDecoration: 'none',
              fontSize: '1.2rem',
              fontWeight: 500
            }}
          >
            www.myfamilymd.org
          </a>
        </div>
      </footer>
    </div>
  )
};

export default Home;